

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'



const PartnerwithUs = () => {



  return (
    <div>
            <Newnavbar />


              <div className="banner_img !py-5">
                <div className="!flex !flex-row !container !mx-auto !py-5">
                    <div className="md:!w-[70%] !w-[100%] !mx-auto px-[20px]">
                        <div className="new_ban_des !flex !justify-center !flex-col">
                            <h2 className="!text-center md:!text-[42px] !text-[20px]">
                                Partner With PayBi
                            </h2>
                            <p className="!text-center">
                                At PayBi, we believe in the power of partnerships to expand value and impact. Whether you're a startup, financial institution, service provider, or enterprise, we’re open to collaborations that drive innovation in expense management and digital finance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div className=" bg-stone-50 flex flex-col">
              <main className="flex-grow nd:py-[60px] py-[30px] ">
                <div className='flex justify-between md:flex-row flex-col w-full  max-w-7xl mx-auto'>
                    <section className=" trust_below_des leading-relaxed md:space-y-[60px] space-y-[30px] md:mt-[20px] mt-[0px] px-[20px]">
                      <div>
                        <p className="!text-[24px] !font-bold !text-gray-900 mb-2">
                          Partnership Opportunities
                        </p>
                        <div>
                          <ul className='!space-y-[10px]'>
                            <li className='!text-[#525252] text-start '>Technology Integrations</li>
                            <li className='!text-[#525252] text-start'>Affiliate & Referral Programs</li>
                            <li className='!text-[#525252] text-start '>Co-branded Financial Solutions</li>
                            <li className='!text-[#525252] text-start '>Corporate & Enterprise Solutions</li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <p className="!text-[24px] !font-bold !text-gray-900 mb-2">
                          Why Partner With Us?
                        </p>
                        <div>
                          <ul className='!space-y-[10px]'>
                            <li className='!text-[#525252] text-start '>Scalable API & secure infrastructure</li>
                            <li className='!text-[#525252] text-start'>Access to growing user base</li>
                            <li className='!text-[#525252] text-start '>Shared growth opportunities</li>
                            <li className='!text-[#525252] text-start '>Dedicated partner support</li>
                          </ul>
                        </div>
                      </div>
                      
                    </section>

                    <div className="new_get_in_touch my-5 !w-fit !flex !justify-center">
                    <div className="flex flex-col md:flex-row items-center mx-auto justify-center">
                        <div className=" new_con_form w-10/12 md:!p-[80px] !p-[16px] !bg-white">
                            <h1>Get in touch with us</h1>
                            <p>Drop your email and Connect with us, and we’ll help bring your ideas to life!</p>
                            <form>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control w-full"
                                        id="email"
                                        placeholder="Enter your Mail"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        className="form-control w-full"
                                        id="name"
                                        placeholder="Enter your Name"
                                    />
                                </div>
                                <button type="submit" >Submit</button>
                            </form>
                        </div>
                    </div>
                    </div>
                </div>

              </main>

    </div>

            <Newfooter />
      
    </div>
  )
}

export default PartnerwithUs
